var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.686 97.075c-.582-7.356-4.021-11.484-6.802-13.653-3.987-3.103-8.799-3.858-12.359-3.52h-6.728v-4.8a36.198 36.198 0 0 0 17.594-53.344 36.205 36.205 0 0 0-16.078-13.696 10.044 10.044 0 0 0-3.939-1.451 36.228 36.228 0 0 0-45.342 24.836 36.219 36.219 0 0 0-.194 18.963c.15 1 .45 1.971.887 2.883A36.399 36.399 0 0 0 95.642 74.11v20.018a19.286 19.286 0 0 0-7.831 15.511v13.454c-.166 6.358 2.369 13.041 6.673 17.487a20.135 20.135 0 0 0 4.227 3.35v.981a10.152 10.152 0 0 0 10.152 10.152h.112l30.714-.339a10.153 10.153 0 0 0 10.041-9.955c.064-3.918.7-38.331-.044-47.694Z",
    fill: "#23A094",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.982 67.63c14.396 0 26.067-11.67 26.067-26.065 0-14.395-11.671-26.065-26.067-26.065-14.397 0-26.068 11.67-26.068 26.065 0 14.395 11.671 26.065 26.068 26.065Z",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.514 41.637a21.651 21.651 0 0 1-14.305 20.35 21.66 21.66 0 0 1-24.006-6.524s8.799 9.647 22.87 2.707c14.541-7.157 15.441-16.533 15.441-16.533Z",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.725 32.019s10.047-4.176 21.844-.802c13.929 3.98 22.846 10.672 26.592 20.045",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.028 16.953s-8.741.904-16.278 16.875c-6.873 14.574-5.573 27.574-4.67 30.89m14.467 2.558s-4.355-5.123-4.673-13.26c-.45-11.6 4.372-18.54 9.645-23.348 6.934-6.328 13.11-4.521 13.11-4.521m-33.456-7.084s4.22 3.464.755 11.45C95.463 38.5 85.967 49.195 85.967 49.195m54.507-15.158c.254 1.293.418 2.603.49 3.919m-5.617-14.229s2.517 2.145 4.199 6.899M82.24 52.197s.873 3.201 2.474 5.384m21.176 43.176V71.725a3.933 3.933 0 0 1 3.932-3.932v0a3.93 3.93 0 0 1 3.932 3.932V90.71",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.302 100.758v-6.639a3.769 3.769 0 0 1 3.77-3.77m11.343 3.768v10.767a3.77 3.77 0 0 1-3.77 3.77v0a3.723 3.723 0 0 1-1.468-.298m-2.302-7.568v-6.669a3.769 3.769 0 0 1 3.77-3.77h6.748",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.025 97.538v7.36a3.768 3.768 0 0 1-3.77 3.769v0a3.77 3.77 0 0 1-3.77-3.769V94.131a3.769 3.769 0 0 1 3.77-3.77m-14.249 10.815s.484 2.318 2.609 2.511c2.125.192 3.093-.288 4.447-1.74",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.256 90.35s7.692-1.303 8.42 7.83c.727 9.132 0 46.695 0 46.695l-30.718.338v-8.422h-.226c-7.313 0-10.867-7.782-10.674-13.24v-13.61a9.135 9.135 0 0 1 9.154-9.153h14.552a3.258 3.258 0 0 1 3.255 3.259v0a4.572 4.572 0 0 1-4.575 4.571l-10.531.048c6.429 2.087 10.758 8.577 10.758 15.321",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.435 112.969s7.106 2.318 9.137 5.363m-5.15-16.022s2.129-1.577 3.77 0c1.959 1.885.724 5.945-2.538 5.367m-5.008-17.327h-7.574",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/Fitness.5b25574f00105874fb7fa697fc9d2e1f.svg";
export { ForwardRef as ReactComponent };